[
  {
    "code": "MA-09",
    "name": "Chaouia-Ouardigha"
  },
  {
    "code": "MA-10",
    "name": "Doukkala-Abda"
  },
  {
    "code": "MA-05",
    "name": "Fès-Boulemane"
  },
  {
    "code": "MA-02",
    "name": "Gharb-Chrarda-Beni Hssen"
  },
  {
    "code": "MA-08",
    "name": "Grand Casablanca"
  },
  {
    "code": "MA-14",
    "name": "Guelmim-Es Smara"
  },
  {
    "code": "MA-04",
    "name": "L'Oriental"
  },
  {
    "code": "MA-15",
    "name": "Laâyoune-Boujdour-Sakia el Hamra"
  },
  {
    "code": "MA-11",
    "name": "Marrakech-Tensift-Al Haouz"
  },
  {
    "code": "MA-06",
    "name": "Meknès-Tafilalet"
  },
  {
    "code": "MA-16",
    "name": "Oued ed Dahab-Lagouira"
  },
  {
    "code": "MA-07",
    "name": "Rabat-Salé-Zemmour-Zaer"
  },
  {
    "code": "MA-13",
    "name": "Sous-Massa-Draa"
  },
  {
    "code": "MA-12",
    "name": "Tadla-Azilal"
  },
  {
    "code": "MA-01",
    "name": "Tanger-Tétouan"
  },
  {
    "code": "MA-03",
    "name": "Taza-Al Hoceima-Taounate"
  }
]